"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CspReporter = void 0;
const TelemetryEvents_1 = require("../models/telemetry/TelemetryEvents");
class CspReporter {
    static register(logger) {
        window.addEventListener("securitypolicyviolation", cspError => {
            CspReporter.report(cspError, logger);
        });
    }
    static report(cspError, logger) {
        try {
            const url = new URL(cspError.blockedURI);
            const cspViolationEvent = new TelemetryEvents_1.CspViolationEvent({
                origin: url.origin,
                pathname: url.pathname,
                violatedDirective: cspError.violatedDirective,
            });
            logger.log(cspViolationEvent);
        }
        catch (e) {
            // ignore logging errors
        }
    }
}
exports.CspReporter = CspReporter;
